import React from 'react';
import styles from './index.module.css';

const Heading = ({children, type = "two", className, ...props}) =>
  <div className={className ? styles[type]+" "+className : styles[type]} {...props}>
    {children}
  </div>

export default Heading
